import { useAuthSessionStore } from '@/store/authSessionStore'
import { isAuthDevBypass } from '@/config/env/auth'
import { DEV_USER_ID } from '@/config/api/devAccessToken'

export function getCurrentUserId() {
  const user = useAuthSessionStore.getState().user
  const fromSession = user?.user_id || user?.id || null
  if (fromSession) return fromSession
  if (isAuthDevBypass()) return DEV_USER_ID
  return null
}
